import { createStore } from 'satcheljs';
export default createStore('conversationsOption', {
    conversationSortOrder: null,
    hideDeletedItems: null,
    globalListViewType: null,
})();
//# sourceMappingURL=store.js.map